"use strict";

var PyDefUtils = require("PyDefUtils");
var utils = require("../utils");

module.exports = function(pyModule) {

	pyModule["DesignGridPanel"] = Sk.misceval.buildClass(pyModule, function($gbl, $loc) {

        $loc["__init__"] = new Sk.builtin.func(PyDefUtils.withRawKwargs(function(kwargs, self) {
            Sk.misceval.call(pyModule["GridPanel"].prototype["__init__"], undefined, undefined, kwargs, self);

            self._anvil.whereWillItLand = function(x, y, width, height, mouseX, mouseY) {
                var scale = "xs"; // hard-code for now

                var rowSpacing = self._anvil.getPropJS("row_spacing");
                var offset = this.element.offset();

                var pxPerCol = (this.element.width()+30) / 12;
                var colWidth = Math.ceil((width||0)/(pxPerCol));
                colWidth = Math.min(Math.max(colWidth, 1),12);
                var colX = Math.min(Math.round((x + width/2 - offset.left + 15)/pxPerCol - colWidth/2), 12 - colWidth);
                colX = Math.max(colX, 0);
                //console.log((x - offset.left), "/", pxPerCol, "->", colX);

                var guidelines = [];

                var rowElts = this.element.children();
                for(var i = 0; i <= rowElts.length; i++) {
                    if (i < rowElts.length) {
                        var thisRowY = $(rowElts[i]).offset().top;
                    } else {
                        var thisRowY = offset.top + this.element.height();
                    }

                    for (var j = 1; j <= 12; j++) {
                        var prevColX = offset.left - 15 + pxPerCol*(j-1);
                        var thisColX = offset.left - 15 + pxPerCol*j;

                        if (i > 0) {
                            guidelines.push({
                                x1: prevColX+15,
                                y1: thisRowY-rowSpacing,
                                x2: prevColX+15,
                                y2: thisRowY-rowSpacing-5,
                            })
                            guidelines.push({
                                x1: prevColX+15,
                                y1: thisRowY-rowSpacing,
                                x2: prevColX+20,
                                y2: thisRowY-rowSpacing,
                            })
                        }

                        if (i < rowElts.length) {
                            guidelines.push({
                                x1: prevColX+15,
                                y1: thisRowY,
                                x2: prevColX+15,
                                y2: thisRowY+5,
                            })
                            guidelines.push({
                                x1: prevColX+15,
                                y1: thisRowY,
                                x2: prevColX+20,
                                y2: thisRowY,
                            })
                        }

                        if (i > 0) {
                            guidelines.push({
                                x1: thisColX-15,
                                y1: thisRowY-rowSpacing,
                                x2: thisColX-15,
                                y2: thisRowY-rowSpacing-5,
                            })
                            guidelines.push({
                                x1: thisColX-15,
                                y1: thisRowY-rowSpacing,
                                x2: thisColX-20,
                                y2: thisRowY-rowSpacing,
                            })
                        }
                        if (i < rowElts.length) {
                            guidelines.push({
                                x1: thisColX-15,
                                y1: thisRowY,
                                x2: thisColX-15,
                                y2: thisRowY+5,
                            })
                            guidelines.push({
                                x1: thisColX-15,
                                y1: thisRowY,
                                x2: thisColX-20,
                                y2: thisRowY,
                            })
                        }
                    }
                }

                // If it's in a zone between rows, it will be inserted between them
                var rowReturn = {childIdx: this.gridComponents.length,
                                 layoutProperties: {row: utils.getRandomStr(6)},
                                 estimatedPosition: {x: offset.left + colX*pxPerCol, // This is 15px too far to the right, which conveniently takes care of the left padding.
                                                     y: offset.top + this.element.height(),
                                                     width: colWidth*pxPerCol - 30, height: 0},
                                 guidelines: guidelines,
                                 updateProperties: {width: "default", height: height}
                                 };
                rowReturn.layoutProperties["width_"+scale] = colWidth;
                rowReturn.layoutProperties["col_"+scale] = colX;

                var addBeforeNextRow = false;
                for (var i=0; i<rowElts.length; i++) {
                    var thisRow = $(rowElts[i]);
                    var ypos = (y + height/2 - thisRow.offset().top)/(thisRow.outerHeight() + rowSpacing);
                    var rowName = thisRow.data("anvil-gridpanel-row");
                    var rowOffset = thisRow.offset();

                    //console.debug(ypos*100, "% through row ", i)

                    if (addBeforeNextRow || (ypos <= 0.25 && (ypos > 0 || i == 0))) {
                        //console.debug("Dropping before row ", i);
                        addBeforeNextRow = false;

                        // Find the idx before the first child to mention rowName
                        for (var j=0; j<this.gridComponents.length; j++) {
                            if (this.gridComponents[j].row == rowName) {
                                rowReturn.childIdx = j;
                                break;
                            }
                        }

                        rowReturn.estimatedPosition.y = rowOffset.top;
                        return rowReturn;
                    } else if (ypos > 0.25 && ypos < 0.75) {
                        // Actual row hit. We know which column the user was aiming for (colX),
                        // then insert the element such that it will land in that column,
                        // displacing others rightwards if necessary.

                        rowReturn.layoutProperties.row = rowName;

                        for (var j=0; j<this.gridComponents.length; j++) {
                            var component = this.gridComponents[j];

                            if (component.row == rowName) {

                                if (component.lastCol[scale] > colX) {
                                    // This element is in the same row, and occupies,
                                    // or is to the right of, our target column.
                                    // Insert before it.
                                    rowReturn.childIdx = j;
                                    break;
                                } else {
                                    // This element is in the same row, but is to the left of our target column. Insert after it.
                                    rowReturn.childIdx = j+1;
                                }
                            }
                        }

                        rowReturn.estimatedPosition.y = rowOffset.top,
                        rowReturn.estimatedPosition.height = thisRow.outerHeight();
                        return rowReturn;
                    } else if (ypos >= 0.75 && ypos <= 1) {
                        addBeforeNextRow = true;
                    }
                }
                // If we have no idea, it will be inserted as a new row at the bottom
                return rowReturn;
            };

            self._anvil.setLayoutProperties = function(pyComponent, props) {
                var elt = pyComponent._anvil.element;

                console.log("GridPanel: Setting width for " + Sk.builtin.str(pyComponent).v + " to " + props.width);

                if (props.width) { elt.css("width", props.width); }

                var ps = {};
                ps[pyComponent._anvil.componentSpec.name] = { width: elt.width(), data_binding: props["data_binding"] };

                return ps;
            }

            self._anvil.getHandles = function(pyChild) {
                if (pyChild) {
                    // Get layout handles for pyChild
                    var e = pyChild._anvil.element;
                    var offset = e.offset();
                    var w = e.outerWidth();
                    var h = e.outerHeight();

                    return [{
                        x: offset.left + w,
                        y: offset.top + h/2 - 5,
                        width: 10,
                        height: 10,
                        cursor: "ew",
                        childName: pyChild._anvil.componentSpec.name,
                        owner: self._anvil.componentSpec.name,
                    }];

                } else {
                    // No handles of our own
                }
            };

            self._anvil.handleGrab = function(handle, mouseX, mouseY) {
                if (handle.pyChild) {
                    // This is a layout handle for one of our children

                    return {
                        mouseX: mouseX,
                        originalHandleX: handle.x,
                        originalColWidth: handle.pyChild._anvil.componentSpec.layout_properties.width_xs,
                    };
                } else {
                    // No handles of our own
                }
            };

            self._anvil.handleDrag = function(handle, grab, mouseX, mouseY) {
                if (handle.pyChild) {
                    // This is a layout handle for one of our children
                    var totalDx = mouseX - grab.mouseX;

                    var colWidthPx = (self._anvil.element.width()+30) / 12;
                    var totalColDx = Math.round(totalDx / colWidthPx);
                    handle.x = grab.originalHandleX + colWidthPx * totalColDx;

                    var newWidth = Math.min(Math.max(1,grab.originalColWidth+totalColDx),12);

                    // TODO: Move other elements so they don't get 'pushed'. Or don't bother, this container is being retired anyway.

                    handle.pyChild._anvil.element.parent().attr("class", function(i, c) {
                        return c.replace(/col-xs-\d+/g, 'col-xs-' + newWidth);
                    });
                } else {
                    // No handles of our own
                }

                return handle;
            };

            self._anvil.handleDrop = function(handle, grab, mouseX, mouseY) {
                if (handle.pyChild) {
                    // This is a layout handle for one of our children
                    var r = { layoutProperties: {}};
                    var totalDx = mouseX - grab.mouseX;

                    var colWidthPx = (self._anvil.element.width()+30) / 12;
                    var totalColDx = Math.round(totalDx / colWidthPx);
                    var newWidth = Math.min(Math.max(1,grab.originalColWidth+totalColDx),12);

                    r.layoutProperties[handle.pyChild._anvil.componentSpec.name] = {
                        width_xs: newWidth,
                    };

                    return r;
                } else {
                    // No handles of our own
                }
            };

        }));
    }, 'DesignGridPanel', [pyModule["GridPanel"]]);
};
